<template>
  <div id="container">
    <div class="product-status">
      <div class="bold" style="top:10px;"></div>
      <div style="position: absolute;top:10px;right:20px;z-index: 99">
        <div>
          <el-checkbox v-model="checked" style="padding-left:16px;"
          >每60秒刷新当前页面
          </el-checkbox>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item, index) in waitPaymentApplicationList"
          :key="index"
        >
        </el-tab-pane>
      </el-tabs>
      <!--      -->
      <div>
        <el-form class="search-style">
          <el-row :gutter="20">
            <el-col :span="4">
              <el-form-item>
                <el-select v-model="queryParams.column" @change="clearParams">
                  <el-option
                    v-for="(item, index) in waitFeedbackEnquiryList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">

              <el-form-item v-show="queryParams.column === 'payType'">
                <el-select v-model="params.value">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                    v-for="(item, index) in cPayType"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-show="queryParams.column === 'orgName'">
                <el-select v-model="params.value">
                  <el-option
                    :label="item.orgName"
                    :value="item.orgName"
                    :disabled="item.disabled"
                    v-for="(item, index) in orgList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-show="queryParams.column === 'state'">
                <el-select v-model="params.value">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                    v-for="(item, index) in payState"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-show="queryParams.column === 'amount' || queryParams.column === 'payAmount'">
                <el-select v-model="params.expression">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                    v-for="(item, index) in expressionList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                v-show="queryParams.column !== 'payType' && queryParams.column !== 'createDate' && queryParams.column !== 'processSecDate' && queryParams.column !== 'orgName' && queryParams.column !== 'state'">
                <el-input
                  v-model="params.value"
                  placeholder="请输入关键词"
                ></el-input>
              </el-form-item>
              <el-form-item v-show='queryParams.column === "createDate" || queryParams.column === "processSecDate"'>
                <el-date-picker
                  v-model="paramsTimer" style="width:100%;" type="daterange" range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm"
                  :default-time="['00:00:00','23:59:59']">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <el-button type="primary" @click="onSearch">搜索</el-button>
                <el-button @click="searchReset" type>重置</el-button>
              </el-form-item>
            </el-col>
            <el-form-item style="float:right;margin-right: 0 !important;" v-show="activeName === '1'">
              <el-button type="primary" :disabled="!list.length" @click="chioesCheck">批量领取</el-button>
            </el-form-item>
          </el-row>
        </el-form>
        <div class="box-table" :style="{height: financeTableHeight + 'px'}">
          <el-table
            border
            ref="tableRef"
            type="reset"
            :data="list"
            :row-class-name="tableRowClassName"
            :max-height="financeTableHeight"
            tooltip-effect="dark"
            :header-cell-style="tableHeader"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              :key="1"
              :selectable="selectableFun"
              v-if="activeName === '1'"
            ></el-table-column>

            <el-table-column
              width="150"
              prop="payNumber"
              label="付款编号"
              :key="2"
            >
              <template slot-scope="scope">
                  <span class="approval" @click="onDetails(scope.row)">{{
                    scope.row.payNumber
                  }}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="payType"
              :key="3"
              label="付款类型">
              <template slot-scope="scope">
                <span>{{ scope.row.payType | payType }}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="amount"
              label="申请付款金额"
              :key="4"
              width="110"
            >
              <template slot-scope="scope">
                {{ scope.row.amount | priceFilter }}
              </template>
            </el-table-column>

            <el-table-column
              prop="payAmount"
              label="实际付款金额"
              width="110"
              :key="5"
              v-if="activeName === '4'"
            >
              <template slot-scope="scope">
                {{ scope.row.payAmount | toFixed }}
              </template>
            </el-table-column>

            <el-table-column
              prop="contractCount"
              label="涉及合同数"
              :key="6"
              width="100"
            ></el-table-column>

            <el-table-column
              prop="initialDueDate"
              label="最初账款到期时间"
              width="140"
              :key="7"
            >
              <template slot-scope="scope">
                {{scope.row.initialDueDate | dateFilterD}}
              </template>
            </el-table-column>

            <el-table-column prop="state" label="付款状态" :key="8">
              <template slot-scope="scope">
                <span>{{ scope.row.state | state }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="mark" label="备注" :key="9">
              <template slot-scope="scope">
                <span>{{ scope.row.mark || '--' }}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="staffCnName"
              label="申请人"
              :key="10"
            ></el-table-column>

            <el-table-column
              prop="orgName"
              label="所属部门"
              :key="11"
            ></el-table-column>

            <el-table-column prop="createDate" label="申请时间" width="150" :key="12">
              <template slot-scope="scope">{{
                scope.row.createDate | formatData
                }}
              </template>
            </el-table-column>

            <el-table-column
              prop="processSecUser"
              v-if="activeName === '1'"
              :key="13"
              label="认领人"
            >
              <template v-slot="{row}">{{row.processSecUser||'--'}}</template>
            </el-table-column>

            <el-table-column
              prop="processSecDate"
              :key="14"
              v-if="
                  activeName !== '3' &&
                    activeName !== '4'
                "
              label="认领时间"
            >
              <template slot-scope="scope">{{
                scope.row.processSecDate | dateFilter
                }}
              </template>
            </el-table-column>

            <el-table-column
              :key="15"
              prop="processUser"
              v-if="
                  activeName === '3' ||
                    activeName === '4'
                "
              label="处理人"
            ></el-table-column>

            <el-table-column
              prop="processDate"
              label="处理时间"
              :key="16"
              v-if="
                  activeName === '3' ||
                    activeName === '4'
                "
            >
              <template slot-scope="scope">
                {{scope.row.processDate | formatData}}
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              :key="17"
              v-if="activeName === '2' || activeName === '3'"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  v-if="scope.row.processSecState === 2"
                  @click="onHandle(scope.row)"
                >处理
                </el-button>
                <el-button
                  type="text"
                  @click="look(scope.row)"
                  v-if="scope.row.state === 6 && activeName === '3'"
                >
                  处理
                </el-button>
                <el-button
                  type="text"
                  @click="onDetails(scope.row)"
                  v-if="scope.row.state !== 6 && activeName === '3'"
                >
                  查看
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              :key="18"
              v-if="activeName === '1'"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="Claim(scope.row)"
                  v-if="scope.row.extract === 1"
                >认领
                </el-button
                >
                <el-button
                  type="text"
                  @click="ondraw(scope.row)"
                  v-if="scope.row.extract === 3"
                >提取
                </el-button>
                <el-button
                  type="text"
                  v-if="scope.row.extract === 2"
                  @click="onHandle(scope.row)"
                >处理
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <pagination
            :total="total"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          ></pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
import {
  waitPaymentApplicationList,
  waitFeedbackEnquiryListex,
  cPayType,
  payState
} from '../financeManage/util/data'
import {
  updateProcessid,
  queryRequestPayList,
  getComAll
} from '@/api/fiance/fianceManage'
import { isSuccess } from '@/util/tool'
import { mapState } from 'vuex'

export default {
  components: {
    pagination: pagination
  },

  data () {
    return {
      test: {
        1: 'aaaa',
        2: 'bbbb'
      },
      row: {},
      miState: 0,
      activeName: '', // tabs选中状态
      waitPaymentApplicationList: waitPaymentApplicationList, // tabs状态
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      cPayType,
      queryParams: {}, // 搜索条件
      params: {},
      waitFeedbackEnquiryList: waitFeedbackEnquiryListex, // 筛选条件
      expressionList: expressionList,
      checked: false,
      state: '',
      id: 0,
      payState,
      chioesList: [],
      paramsTimer: [],
      orgList: []
    }
  },
  mounted () {
    this.activeName = '1'
    this.getList()
    this.getOrgList()
  },
  computed: {
    ...mapState(['financeTableHeight'])
  },
  watch: {
    checked (newVal) {
      clearInterval(this.timer)
      if (newVal) {
        this.timer = setInterval(() => {
          this.getList()
        }, 60000)
      }
      return newVal
    },
    activeName (newVal) {
      switch (newVal) {
        case '1':
          this.waitFeedbackEnquiryList = [...waitFeedbackEnquiryListex,
            {
              label: '认领人',
              value: 'processSecUser'
            },
            {
              label: '认领时间',
              value: 'processSecDate'
            }]
          break
        case '2':
          this.waitFeedbackEnquiryList = [...waitFeedbackEnquiryListex,
            {
              label: '认领时间',
              value: 'processSecDate'
            }]
          break
        case '3':
          this.waitFeedbackEnquiryList = [...waitFeedbackEnquiryListex,
            {
              label: '处理人',
              value: 'processSecUser'
            },
            {
              label: '处理时间',
              value: 'processSecDate'
            }]
          break
        case '4':
          this.waitFeedbackEnquiryList = [...waitFeedbackEnquiryListex,
            {
              label: '实际付款金额',
              value: 'payAmount'
            },
            {
              label: '付款状态',
              value: 'state'
            },
            {
              label: '处理人',
              value: 'processSecUser'
            },
            {
              label: '处理时间',
              value: 'processSecDate'
            }]
          break
      }
      return newVal
    }
  },
  updated () {

  },
  filters: {
    payType (payType) {
      if (payType === 1) {
        return '客户提现'
      } else if (payType === 2) {
        return '采购付款'
      } else if (payType === 3) {
        return '供应商充值'
      } else if (payType === 4) {
        return '退货罚没金'
      } else if (payType === 5) {
        return '维修付款'
      } else if (payType === 6) {
        return '采购退货罚款'
      }
    },
    state (state) {
      if (state === 1) {
        return '付款审核'
      } else if (state === 2) {
        return '待处理'
      } else if (state === 3 || state === 7) {
        return '审核不通过'
      } else if (state === 4) {
        return '审核不通过（退回成功）'
      } else if (state === 5) {
        return '付款成功'
      } else if (state === 6) {
        return '付款失败'
      }
    }
  },
  methods: {
    getOrgList () {
      getComAll().then(res => {
        if (isSuccess(res)) {
          this.orgList = res.data.obj && res.data.obj.filter(item => item.orgFatherId !== 0)
        }
      })
    },
    clearParams () {
      this.params = {}
    },
    // 重置
    searchReset () {
      this.params = {}
      this.queryParams = {}
      this.getList()
    },
    // 搜索
    searchFor () {
      this.getList()
    },
    // 我的已审核详情
    onDetails (row) {
      this.$router.push({
        name: 'overcliaminList',
        query: { payNumber: row.payNumber, type: row.payType }
      })
    },
    // 审批
    approval (row) {
      this.$router.push({
        name: 'finishApplyList',
        query: { payNumber: row.payNumber, type: row.payType }
      })
    },
    // 查看
    look (row) {
      this.$router.push({
        name: 'overcliaminList',
        query: { payNumber: row.payNumber, type: row.payType, again: 1 }
      })
    },
    // 认领
    Claim (row) {
      if (row.processSecState === 3) {
        this.$message.error('待审批付款申请已被认领！')
      } else {
        updateProcessid(2, 1, [row.payNumber], 'updateProcessClaim')
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('认领成功！')
              this.getList()
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    selectableFun (row) {
      return row.processSecState === 1
    },
    // 批量认领
    chioesCheck () {
      if (this.chioesList.length === 0) {
        this.$message.error('请选择一条或多条！')
      } else {
        var list = []
        this.chioesList.forEach(item => {
          list.push(item.payNumber)
        })
        updateProcessid(2, 1, list, 'updateProcessClaimAll')
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('认领成功！')
              this.getList()
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    // 提取
    ondraw (row) {
      updateProcessid(1, 1, [row.payNumber], 'updateProcessExtract')
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('提取成功！')
            this.getList()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 处理
    onClaim (row) {
      if (row.processSecState === 3) {
        this.$message.error('该付款申请已被处理！')
      } else {
        this.$router.push({
          name: 'cliaminList',
          query: { payNumber: row.payNumber, type: row.payType }
        })
      }
    },
    // 已处理
    onHandle (row) {
      this.$router.push({
        name: 'cliaminList',
        query: { payNumber: row.payNumber, type: row.payType }
      })
    },
    // tabs切换时触发的事件
    handleClick (tab) {
      this.currentPage = 1
      this.activeName = tab.name
      this.queryParams = {}
      this.params = {}
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList () {
      this.loadingTable = true
      if (this.activeName === '1') {
        this.miState = 1
      } else if (this.activeName === '2') {
        this.miState = 2
      } else if (this.activeName === '3') {
        this.miState = 3
      } else if (this.activeName === '4') {
        this.miState = 4
      }
      const params = {
        criteriaVoList: this.$queryParams(this.queryParams, this.params),
        queryPageName: ''
      }
      queryRequestPayList(this.miState, this.currentPage, this.pageSize, params)
        .then(res => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = (res.data.obj.records[0] && res.data.obj.records[0].financePayRequestListVoList) || []
            this.total = res.data.obj.total
            this.$nextTick(() => {
              try {
                this.$refs.tableRef.doLayout()
              } catch (e) {
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 搜索
    onSearch () {
      if ((this.queryParams.column === 'createDate' || this.queryParams.column === 'processSecDate') && this.paramsTimer.length === 2) {
        this.params.value = this.paramsTimer[0]
        this.params.endValue = this.paramsTimer[1]
      }
      if (this.params.value === '' || this.params.value === undefined) {
        this.$message.error('搜索条件不能为空')
      } else if (!this.queryParams.column) {
        this.$message.error('请选择搜索选项')
      } else {
        this.getList()
      }
    },
    handleSelectionChange (val) {
      this.chioesList = val
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    tableRowClassName ({ row }) {
      if (row.state === 6) {
        return 'warning-row'
      }
    }
  }
}
</script>
